import { createI18n } from 'vue-i18n'
import { fr as vuetifyFr, en as vuetifyEn } from 'vuetify/locale'

import en from './locales/en.json'
import fr from './locales/fr.json'

// Import Vuetify locales

// Function to get the initial locale
function getInitialLocale() {
    try {
        const persistedState = JSON.parse(localStorage.getItem('app')) // 'app' is the key for useAppStore
        if (persistedState && persistedState.locale) {
            return persistedState.locale
        }
    } catch (e) {
        console.error('Could not parse persisted state from localStorage:', e)
    }
    return navigator.language.split('-')[0] || 'fr'
}

const i18n = createI18n({
    legacy: false,
    locale: getInitialLocale(),
    fallbackLocale: 'fr',
    messages: {
        fr: {
            ...fr,
            $vuetify: {
                ...vuetifyFr,
            },
        },
        en: {
            ...en,
            $vuetify: {
                ...vuetifyEn,
            },
        },
    },
})

export default i18n
